var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Cookies from "js-cookie";
class InfoBar {
  constructor() {
    __publicField(this, "handleClose", (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      const $bar = $btn.closest(this.infoBarSelector);
      const cookieName = $bar.data("cookiename");
      Cookies.set(cookieName, 1, {expires: 31, path: ""});
      $bar.slideUp();
    });
    this.$close = $(".js-header-infobar-close");
    this.infoBarSelector = ".js-header-infobar";
  }
  init() {
    this.$close.on("click", this.handleClose);
  }
}
export default InfoBar;
